import { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { CATEGORIES, categoryName } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const Products = () => {
    const [params, setParams] = useSearchParams();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const active = params.get("category") || "all";

    useEffect(() => {
        setLoading(true);
        const q = active !== "all" ? { category: active } : {};
        api.get("/products", { params: q })
            .then(({ data }) => setItems(data))
            .finally(() => setLoading(false));
    }, [active]);

    const tabs = useMemo(() => [{ slug: "all", name: "All Machinery" }, ...CATEGORIES], []);

    return (
        <div data-testid="catalog-page">
            <section className="border-b border-gray-200 bg-white">
                <div className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16">
                    <div className="overline text-red-600 mb-6">Catalog · Production Equipment</div>
                    <h1 className="font-display font-black uppercase tracking-tighter text-5xl md:text-7xl">
                        Machinery Catalog
                    </h1>
                    <p className="mt-6 max-w-2xl text-gray-600">
                        Industrial-grade equipment for stainless steel cup &amp; thermos production lines —
                        from tube mills to vacuum sealers and printing systems.
                    </p>
                </div>

                <div className="max-w-7xl mx-auto px-6 md:px-12 pb-6 flex flex-wrap gap-2">
                    {tabs.map((t) => {
                        const isActive = active === t.slug;
                        return (
                            <button
                                key={t.slug}
                                onClick={() => {
                                    if (t.slug === "all") setParams({}); else setParams({ category: t.slug });
                                }}
                                data-testid={`filter-${t.slug}`}
                                className={`px-5 py-3 font-mono text-[11px] uppercase tracking-[0.22em] border transition-colors ${
                                    isActive
                                        ? "bg-gray-900 text-white border-gray-900"
                                        : "bg-white text-gray-900 border-gray-300 hover:border-gray-900"
                                }`}
                            >
                                {t.name}
                            </button>
                        );
                    })}
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
                {loading ? (
                    <div className="text-gray-500 font-mono text-xs uppercase tracking-[0.3em]" data-testid="catalog-loading">Loading machinery…</div>
                ) : items.length === 0 ? (
                    <div className="py-20 text-center text-gray-500" data-testid="catalog-empty">
                        No products in this category yet.
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
                        {items.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
                    </div>
                )}
            </section>
        </div>
    );
};

export default Products;
